import React from 'react';

function SuccessContent({title, message}) {
    return (
        <div className="login-container d-flex align-items-center justify-content-center" style={{background: 'url(/waves-white.png)'}}>
            <div className="card shadow-lg p-4">
                <div className="card-body">
                    <a href="/">
                        <img src="/logo.png" className="logo-login-top" alt="GeoTrace"/>
                    </a>
                    <div className="alert alert-dismissible alert-success" style={{marginTop: '30px', marginBottom: '30px'}}>
                        <h4 className="alert-heading">{title}</h4>
                        <p className="mb-0">{message}</p>
                    </div>
                    <div className="d-flex justify-content-between">
                        <a href="/" className="btn btn-primary w-100">
                            Iniciar sesión
                        </a>
                    </div>
                    <div className="text-center">
                        <img src="/logo-footer.png" className="logo-login-bottom" alt="GeoTrace"/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SuccessContent;